import { render, staticRenderFns } from "./mstradvbrand.vue?vue&type=template&id=74d2c699"
import script from "./mstradvbrand.vue?vue&type=script&lang=js"
export * from "./mstradvbrand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports